import { useState } from 'react';
import { UserManagement } from '@/components/admin/users/user-management';
import { useToast } from '@/hooks/use-toast';
import type { AdminUser } from '@/lib/types';

// Mock data for demonstration
const mockUsers: AdminUser[] = [
  {
    id: '1',
    email: 'admin@flexhelp.com',
    name: 'Admin User',
    role: 'admin',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    lastLogin: '2024-01-15T10:00:00Z',
    permissions: ['all'],
    lastActivity: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    email: 'manager@flexhelp.com',
    name: 'Facility Manager',
    role: 'facility_manager',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    lastLogin: '2024-01-14T15:30:00Z',
    permissions: ['manage_properties', 'manage_tasks'],
    lastActivity: '2024-01-14T15:30:00Z',
  },
];

export function UsersPage() {
  const [users] = useState(mockUsers);
  const { toast } = useToast();

  const handleAddUser = () => {
    toast({
      title: 'Coming Soon',
      description: 'This feature will be available soon.',
    });
  };

  const handleEditUser = (user: AdminUser) => {
    toast({
      title: 'Coming Soon',
      description: 'This feature will be available soon.',
    });
  };

  const handleDeactivateUser = (userId: string) => {
    toast({
      title: 'Coming Soon',
      description: 'This feature will be available soon.',
    });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">User Management</h1>
      <UserManagement
        users={users}
        onAddUser={handleAddUser}
        onEditUser={handleEditUser}
        onDeactivateUser={handleDeactivateUser}
      />
    </div>
  );
}